'use client';

import { Flex } from '@chakra-ui/react';
import { usePathname } from 'next/navigation';

import { PaginationBlock } from '@ui/pagination';

interface Props {
  articlesPagesTotal: number;
  page?: number;
}

export default function BlogPaginator({ articlesPagesTotal, page = 1 }: Props) {
  const pathname = usePathname();

  return (
    <Flex justifyContent="center" py={14}>
      <PaginationBlock
        total={articlesPagesTotal}
        page={page}
        pageSize={6}
        buildHref={(p) => `${pathname.replace(/(\/\d+)$/, '')}/${p}`}
      />
    </Flex>
  );
}
